import React from "react";
import {Trans, useTranslation} from "react-i18next";
import Flashbar from "@awsui/components-react/flashbar";
import Link from "@awsui/components-react/link";


const NoOpenCompetitionsFlashbar: React.FC = () => {
    const {t} = useTranslation("lineup");
    return (
        <Flashbar items={[{
            type: "info",
            header: t("noOpenCompetitions.header"),
            content: (
                <Trans
                    t={t}
                    i18nKey="noOpenCompetitions.content"
                    components={[<Link href="/standings" variant="primary" color="inverted">standings</Link>]}
                />
            ),
            dismissible: false
        }]} />
    );
};

export default NoOpenCompetitionsFlashbar;
